import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedSchool: null,
  status: 'idle',
  error: null,
};

const selectedSchoolSlice = createSlice({
  name: 'selectedSchool',
  initialState,
  reducers: {
    setSelectedSchool(state, action) {
      state.selectedSchool = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearSelectedSchool(state) {
      state.selectedSchool = null;
      state.status = 'idle';
      state.error = null;
    },
    setError(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const { setSelectedSchool, clearSelectedSchool, setError } = selectedSchoolSlice.actions;

export default selectedSchoolSlice.reducer;